module.exports = __webpack_public_path__ + "static/media/360-arrow-royal.3bd71f95.svg";